<ngx-intl-tel-input
		[cssClass]="'form-control'"
		[preferredCountries]="preferredCountries"
		[enableAutoCountrySelect]="true"
		[enablePlaceholder]="true"
		[searchCountryFlag]="true"
		[searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
		[selectFirstCountry]="false"
		[selectedCountryISO]="defaultCountry"
		[maxLength]="15"
    [separateDialCode]="separateDialCode"
		[phoneValidation]="true"
		[inputId]="fieldId"
    [formControl]="control"
    (countryChange)="onCountryChange_internal($event)"
    [numberFormat]="PhoneNumberFormat.International"
		name="phone"
    ></ngx-intl-tel-input>
		<!-- [selectedCountryISO]="CountryISO.Ireland" -->
